/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Provider_OpenaiInputs */

const en_byoa_provider_openai = /** @type {(inputs: Byoa_Provider_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

const id_byoa_provider_openai = /** @type {(inputs: Byoa_Provider_OpenaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAI`)
};

/**
* | output |
* | --- |
* | "OpenAI" |
*
* @param {Byoa_Provider_OpenaiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_provider_openai = /** @type {((inputs?: Byoa_Provider_OpenaiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Provider_OpenaiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_provider_openai(inputs)
	return en_byoa_provider_openai(inputs)
});